import React from 'react'
import "./badges.css";

export default function Badges () {
    return(
        <>
        <section className="section" id="badges">
                <div className="container">
                    <div className="row">
         <div className="center-heading">
                            <h2>Multitasker And Its <em>Badges</em></h2>
                            <p>By following these principles and providing a quality experience, you’ll keep Posters coming back to the platform and creating more earning opportunities while earning badges</p>                        </div>
        <main>
            <ul class="infoGraphic"> 
                <li>
                <div class="numberWrap">
                    <div class="number fontColor1">1</div>
                    <div class="coverWrap">
                    <div class="numberCover"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="icon iconCodepen"></div>
                    <h2>Children</h2>
<p>show you have worked with kids and you are SCARS and CPR trained</p>
                </div>
                </li>
                <li>
                <div class="numberWrap">
                    <div class="number fontColor2">2</div>
                    <div class="coverWrap">
                    <div class="numberCover"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="icon iconSocial"></div>
                    <h2>Reliable</h2>
                    <p>Take pride in your work, be conﬁdent in your skills, price fairly and accurately</p>
                </div>
                </li>
                <li>
                <div class="numberWrap">
                    <div class="number  fontColor3">3</div>
                    <div class="coverWrap">
                    <div class="numberCover"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="icon iconAirplane"></div>
                    <h2>Professional</h2>
                    <p> uphold a reputation of quality by delivering a professional service.</p>
                </div>
                </li>
                {/* <li>
                <div class="numberWrap">
                    <div class="number  fontColor4">4</div>
                    <div class="coverWrap">
                    <div class="numberCover"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="icon iconMap"></div>
                    <h2>Professional</h2>
                    <p>Sagittis, audantium sem eveniet lacus pede porttitor aenean.</p>
                </div>
                </li>
                <li>
                <div class="numberWrap">
                    <div class="number  fontColor5">5</div>
                    <div class="coverWrap">
                    <div class="numberCover"></div>
                    </div>
                </div>
                <div class="content">
                    <div class="icon iconBulb"></div>
                    <h2>Educate</h2>
                    <p>Sagittis, audantium sem eveniet lacus pede porttitor aenean.</p>
                </div>
                </li> */}
            </ul>

            </main>
            </div>
            </div>
            </section>
        
        </>
    )
    
}